import { CanActivateFn } from '@angular/router';
import { StorageUtil } from '../utils/storage.util';

export const superInvoicingMarinaGuard: CanActivateFn = (route, state) => {
  const marinaId = StorageUtil.getMarinaId();
  if (marinaId == 109) {
    return true;
  } else {
    return false;
  }
};
